// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".react-datepicker-wrapper input{border:0.0625rem solid #e7eaf3;border-radius:0.3125rem;color:#343a40;padding:0.625rem 1rem;width:100%}.react-datepicker-wrapper{width:100%}\n", ""]);
// Exports
module.exports = exports;
